import type { PlanEditorConfiguration } from "../types/plan-editor.types";

export interface ResolvedConfigFlags {
  useAutoHeight: boolean;
  stickyHeader: boolean;
  /** Normalised to a CSS length so callers can drop it straight into a var. */
  stickyHeaderTop: string;
}

export function resolveConfigFlags(
  configuration: PlanEditorConfiguration | undefined,
): ResolvedConfigFlags {
  const top = configuration?.stickyHeaderTop ?? 0;
  return {
    useAutoHeight: configuration?.autoHeight ?? false,
    stickyHeader: configuration?.stickyHeader ?? false,
    stickyHeaderTop: typeof top === "number" ? `${top}px` : top,
  };
}
